const part = [
    // {
    //     path: 'seedFarm-management-list',
    //     name: 'seedFarm-management-list',
    //     meta: {
    //         icon: 'md-apps',
    //         title: '苗场列表',
    //         notCache: true,
    //         access: ['S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-list/seedFarm-list')
    // },
    // {
    //     path: 'seedFarm-preSale-setting',
    //     name: 'seedFarm-preSale-setting',
    //     meta: {
    //         icon: 'md-people',
    //         title: '预售设置',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-preSale-setting/seedFarm-preSale-setting')
    // },
    // {
    //     path: 'seedFarm-distributionStation-cost-setting',
    //     name: 'seedFarm-distributionStation-cost-setting',
    //     meta: {
    //         icon: 'md-people',
    //         title: '转运站物流费用设置',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-distributionStation-cost-setting/seedFarm-distributionStation-cost-setting')
    // },
    // {
    //     path: 'seedFarm-distributionStation-unit-setting',
    //     name: 'seedFarm-distributionStation-unit-setting',
    //     meta: {
    //         icon: 'md-apps',
    //         title: '转运站单位运费',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-distributionStation-unit-setting/seedFarm-distributionStation-unit-setting')
    // },
    // {
    //     path: 'seedFarm-curSale-distributionStation-setting',
    //     name: 'seedFarm-curSale-distributionStation-setting',
    //     meta: {
    //         icon: 'md-apps',
    //         title: '现售配送销售资格',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-curSale-distributionStation-setting/seedFarm-curSale-distributionStation-setting')
    // },
    // {
    //     path: 'seedFarm-block-dist',
    //     name: 'seedFarm-block-dist',
    //     meta: {
    //         icon: 'md-apps',
    //         title: '禁售区域',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-block-dist/seedFarm-block-dist')
    // },
    // {
    //     path: 'seedFarm-qualify-fail-report-list',
    //     name: 'qualify-fail-report-list',
    //     meta: {
    //         icon: 'ios-medical',
    //         title: '质检不合格通知书',
    //         notCache: true,
    //         access: ['B', 'C', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/warehouse-management/qualifyFail-report/qualifyFail-report-list')
    // },
    // {
    //     path: 'preSale-plan',
    //     name: 'preSale-plan',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '供货计划',
    //         notCache: false,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/preSale-management/preSale-plan/preSale-plan')
    // },
    {
        path: 'preSale-plan-V2',
        name: 'preSale-plan-V2',
        meta: {
            icon: 'ios-apps',
            title: '供货计划',
            notCache: false,
            access: ['B', 'C'],
            items: [
            ]
        },
        component: () => import('@/view/preSale-management/preSale-plan/preSale-planV2')
    },
    {
        path: 'productPrice-list',
        name: 'productPrice-list',
        meta: {
            icon: 'ios-apps',
            title: '产品价格管理',
            notCache: false,
            access: ['S', 'B', 'C'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/productPrice-management/productPrice-list')
    },
    {
        path: 'promotion-list',
        name: 'promotion-list',
        meta: {
            icon: 'ios-apps',
            title: '商品优惠',
            notCache: true,
            access: ['B', 'C', 'I', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/promotion-list/promotion-list')
    },
    {
	    path: 'customer-promotion-list',
	    name: 'customer-promotion-list',
	    meta: {
	        icon: 'ios-apps',
	        title: '客户优惠',
	        notCache: true,
	        access: ['B', 'C', 'I', 'S'],
	        items: [
	        ]
	    },
	    component: () => import('@/view/seedFarm-management/promotion-list/customer-promotion-list')
    },
    // {
    //     path: 'seedfarm-promotion-list',
    //     name: 'seedfarm-promotion-list',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '苗场优惠',
    //         notCache: true,
    //         access: ['B', 'C', 'I', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/promotion-list/seedfarm-promotion-list')
    // },
    // {
    //     path: 'seedfarm-manual-promotion-list',
    //     name: 'seedfarm-manual-promotion-list',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '人工优惠',
    //         notCache: true,
    //         access: ['B', 'C', 'I', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/promotion-list/seedfarm-manual-promotion-list')
    // },
    // {
    //     path: 'product-agent-list',
    //     name: 'product-agent-list',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '内部购销',
    //         notCache: true,
    //         access: ['B', 'C', 'I', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/product-agent-list/product-agent-list')
    // },
    // {
    //     path: 'seed-farm-compensation',
    //     name: 'seed-farm-compensation',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '缺货退款单',
    //         notCache: true,
    //         access: ['B', 'C'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/sale-management/compensation/compensation-list')
    // },
    // {
    //     path: 'seedFarm-deposit-station-setting',
    //     name: 'seedFarm-deposit-station-setting',
    //     meta: {
    //         icon: 'ios-apps',
    //         title: '转运站定金分配',
    //         notCache: true,
    //         access: ['B', 'C', 'I', 'S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/seedFarm-management/seedFarm-deposit-station-setting/seedFarm-deposit-station-setting')
    // },
    {
        path: 'seedFarm-user-list',
        name: 'seedFarm-user-list',
        meta: {
            icon: 'ios-apps',
            title: '苗场账号',
            notCache: true,
            access: ['B'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/seedFarm-user-list/seedFarm-user-list')
    },
    {
        path: 'sale-help-order',
        name: 'sale-help-order',
        meta: {
            icon: 'ios-apps',
            title: '代下单',
            notCache: false,
            access: ['B', 'C'],
            items: [
            ]
        },
        component: () => import('@/view/sale-management/sale-help-put-cart/sale-help-put-cart')
    },
    {
        path: 'seedFarm-commission',
        name: 'seedFarm-commission',
        meta: {
            icon: 'ios-apps',
            title: '佣金设置',
            notCache: false,
            access: ['B'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/seedFarm-commission/seedFarm-commission')
    },
    {
        path: 'seedFarm-commission-RecordList',
        name: 'seedFarm-commission-RecordList',
        meta: {
            icon: 'ios-apps',
            title: '佣金修改记录',
            notCache: false,
            access: ['B', 'S', 'I'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/seedFarm-commission/seedFarm-commission-list')
    },
    {
        path: 'seedFarm-additional',
        name: 'seedFarm-additional',
        meta: {
            icon: 'ios-apps',
            title: '抛头/赠送率',
            notCache: false,
            access: ['B', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/seedFarm-additional/seedFarm-additional')
    },
    {
        path: 'seedFarm-additional-list',
        name: 'seedFarm-additional-list',
        meta: {
            icon: 'ios-apps',
            title: '抛头/赠送率修改记录',
            notCache: false,
            access: ['B', 'S'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/seedFarm-additional/seedFarm-additional-list')
    },
    // {
    // 	path: 'seedFarm-additionalRate-list',
    // 	name: 'seedFarm-additionalRate-list',
    // 	meta: {
    // 		icon: 'ios-apps',
    // 		title: '苗场定金比例设置',
    // 		notCache: false,
    // 		access: ['B','S'],
    // 		items: [
    // 		]
    // 	},
    // 	component: () => import('@/view/seedFarm-management/seedFarm-additionalRate/seedFarm-additionalRate-list')
    // },
    {
        path: 'relationship-recognition-list',
        name: 'relationship-recognition-list',
        meta: {
            icon: 'ios-apps',
            title: '认可关系管理',
            notCache: false,
            access: ['B', 'S', 'J'],
            items: [
            ]
        },
        component: () => import('@/view/seedFarm-management/relationship-recognition/relationship-recognition-list')
    }
];

export default part;
